import { Component, OnInit } from '@angular/core';
import { AuthService } from './app-services/auth.service';
import { Observable } from 'rxjs/Observable';
import { UserService } from './app-services/user.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { RegisterComponent } from './register/register.component';
import { ContactComponent } from './contact/contact.component';
import { LoginComponent } from './login/login.component';
import { NetworthHelpComponent } from './networth-help/networth-help.component';
import { Router, NavigationEnd } from '@angular/router';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { AnalyticsService } from './app-services/analytics.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  public goalName = '';

  isLoggedIn$: Observable<boolean>;
  isAdmin$: Observable<boolean>;
  isHomepage$;

  constructor(public auth: AuthService,
              private userService: UserService,
              private analytics: AnalyticsService,
              public dialog: MatDialog,
              private router: Router) {
                this.router.events.subscribe(event => {
                  if (event instanceof NavigationEnd) {
                    (<any>window).gtag('config', 'UA-118916262-1', {
                      'page_title' : event.urlAfterRedirects,
                      'page_path': event.urlAfterRedirects
                    });
                  }
                });

                router.events.subscribe(event => {
                  if (event instanceof NavigationEnd ) {
                    if (this.router.url === '/' ||
                    this.router.url === '/#top-feature' ||
                    this.router.url === '/#pricing-section' ||
                    this.router.url === '/#landing-goals') {
                      this.isHomepage$ = true;
                    }else {
                      this.isHomepage$ = false;
                    }
                  }
                });
              }



  ngOnInit(): void {
    this.isLoggedIn$ = this.auth.isLoggedIn;
    this.isAdmin$ = this.auth.isAdmin;

    // get the user currency in case the page is refreshed
    if (!this.auth.isTokenExpired()) {
      this.userService.getUserCurrency();
    }
  }

  onLogout() {
    this.auth.logout();
  }

  openFeedback() {
    const dialogRef = this.dialog.open(ContactComponent, {
      width: '450px',
    });
  }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app.component.ts